import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import circle1 from '../../Assests/circle1.png'
import circle2 from '../../Assests/circle2.png'
import circle3 from '../../Assests/circle3.png'
import circle4 from '../../Assests/circle4.png'
import circle5 from '../../Assests/circle5.png'
import circle6 from '../../Assests/circle6.png'
import circle7 from '../../Assests/circle7.png'
import circle8 from '../../Assests/circle8.png'
const services = [
  {
    title: "Mobile & Landline Bills",
    icon: circle1,
  },
  {
    title: "Insurance",
    icon: circle2,
  },
  {
    title: "Internet Bills",
    icon: circle3,
  },
  {
    title: "Electricity Bill",
    icon:   circle4,
  },
  {
    title: "Credit Card Bill",
    icon: circle5,
  },
  {
    title: "FASTag",
    icon: circle6,
  },
  {
    title: "Loan Pay",
    icon: circle7,
  },
  {
    title: "Other Recharges",
    icon: circle8,
  },
];

const ExpandedServices = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 8,
        px: 2,
        backgroundColor: "#fff",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "#2979ff",
          fontWeight: 600,
          mb: 1,
        }}
      >
        Powering Your Essentials
      </Typography>

      <Typography
        variant="h5"
        sx={{
          fontWeight: 500,
          color: "#111827",
          mb: 1,
          fontFamily: "SF Pro Display, sans-serif",
        }}
      >
        Unlocking New Possibilities with
      </Typography>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 500,
          color: "#111827",
          mb: 2,
          fontFamily: "SF Pro Display, sans-serif",
        }}
      >
        Expanded Services
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "#6b7280",
          mb: 5,
          fontSize: "14px",
        }}
      >
        Expanding our capabilities to serve you better—explore our newly added <br/>
        services tailored for modern businesses.
      </Typography>

      <Grid
        container
        spacing={1}
        justifyContent="center"
        sx={{ maxWidth: "1000px", mx: "auto" }}
      >
        {services.map((service, index) => (
          <Grid item size={{xs: 12, sm: 4, md: 2.3}} key={index}>
            <Card
              elevation={0}
              sx={{
                borderRadius: "50%",
                p: 2,
                transition: "transform 0.3s",
                "&:hover": { transform: "translateY(-6px)" },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    
                   
                    p: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={service.icon}
                    alt={service.title}
                    sx={{ width: 100, height: 100, mb: 1 }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#111827",
                      fontWeight: 500,
                      mt: 1,
                      fontFamily: "SF Pro Display, sans-serif",
                    }}
                  >
                    {service.title}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ExpandedServices;
